module.exports = __webpack_public_path__ + "static/media/temp-foto-hero-2.9b3c6f73.jpg";